export const CarrierTab = {
  CARRIER_LIST: 'list',
  FIND_CARRIER: 'search',
};
